module.exports = __webpack_public_path__ + "static/img/ABUIABAEGAAg28LjkQYomcLzPTCYBDhY.5874f9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABUIABAEGAAg28LjkQYomcLzPTCYBDhY.png
// module id = YAal
// module chunks = 1